import i18n from "@/i18n/config"

/**
 * Gets the standardized language code from i18n configuration.
 * Converts "nb" (Norwegian Bokmål) to "no" to match standard language codes
 * used in URLs and analytics, while preserving other language codes as-is.
 *
 * @returns The standardized language code (e.g., "no", "sv", "en")
 */
export const getLanguageCode = (): string => {
  const intlLang = new Intl.Locale(i18n.language).language
  return intlLang === "nb" ? "no" : intlLang
}
